import type { FeatureCollection } from "geojson";
import type { GeometryResult } from "../../../domain/geometry/types";
import type { UndoableCommand } from "../undoStack";

export interface DeletePolygonResult {
	command: UndoableCommand;
	fc: FeatureCollection;
}

/**
 * Remove a feature at the given index from a FeatureCollection.
 */
export function deletePolygonUseCase(
	fc: FeatureCollection,
	featureIndex: number,
	applyResult: (fc: FeatureCollection) => void,
	revert: (fc: FeatureCollection) => void,
): GeometryResult<DeletePolygonResult> {
	if (featureIndex < 0 || featureIndex >= fc.features.length) {
		return { ok: false, error: `Feature index ${featureIndex} out of bounds` };
	}

	const newFC: FeatureCollection = {
		...fc,
		features: fc.features.filter((_, i) => i !== featureIndex),
	};

	return {
		ok: true,
		data: {
			fc: newFC,
			command: {
				label: "Delete polygon",
				execute: () => applyResult(newFC),
				undo: () => revert(fc),
			},
		},
	};
}
